import type { Player } from "."

export const getDefaultPlayerName = ({
  playerId,
}: {
  playerId: Player.Id
}): string => {
  return `Player ${playerId + 1}`
}
